"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var jsError_1 = require("../plugins/jsError");
var network_1 = require("../plugins/network");
var resource_1 = require("../plugins/resource");
var pv_1 = require("../plugins/pv");
var startup_1 = require("../plugins/startup");
var fsp_1 = require("../plugins/fsp");
var mtTracker_1 = tslib_1.__importDefault(require("../trackers/mtTracker"));
var base_1 = tslib_1.__importStar(require("./base"));
/**
 * 基础包只加载 JS异常、网络性能、启动性能指标
 */
mtTracker_1.default.use(jsError_1.PluginError);
mtTracker_1.default.use(network_1.PluginNetwork);
mtTracker_1.default.use(startup_1.PluginStartup);
mtTracker_1.default.use(pv_1.PluginPv);
mtTracker_1.default.use(fsp_1.PluginFsp);
mtTracker_1.default.use(resource_1.PluginResource);
var perf = base_1.default(mtTracker_1.default);
base_1.handlePreInit(perf);
exports.default = perf;
//# sourceMappingURL=mt.base.js.map